import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'vpfe-side-nav-customer',
  templateUrl: './side-nav-customer.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavCustomerComponent {}
